import { db } from "../Config";
import moment from "moment";

export const fetchResumenMensajes = async (empresaId, year) => {
  let stats = [];
  const startOfYear = `${year}-01-01`;
  const endOfYear = `${year}-12-31`;
  
  await db
    .collection("empresas")
    .doc(empresaId)
    .collection("resumen_mensajes")
    .where("fecha", ">=", startOfYear)
    .where("fecha", "<=", endOfYear)
    .get()
    .then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        stats.push(doc.data());
      });
    })
    .catch((err) => {
      throw new Error(err);
    });
    
  return stats;
};

export const fetchMensajesEnviadosDesdeUltimoPago = async (empresaId, fecUltPago) => {
  try {
    let startDate;
    if (fecUltPago) {
      startDate = typeof fecUltPago.toDate === "function" ? fecUltPago.toDate() : new Date(fecUltPago);
    } else {
      startDate = moment().startOf("month").toDate();
    }

    const startDateStr = moment(startDate).format("YYYY-MM-DD");

    const querySnapshot = await db
      .collection("empresas")
      .doc(empresaId)
      .collection("resumen_mensajes")
      .where("fecha", ">=", startDateStr)
      .get();

    let sentCount = 0;
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      sentCount += data.outboundCount || 0;
    });

    return sentCount;
  } catch (error) {
    console.error("Error al contar mensajes enviados:", error);
    throw error;
  }
};

